import { useEffect, useState } from "react";

export function useTitleWatcher() {
  const [title, setTitle] = useState(document.title);

  useEffect(() => {
    const el = document.querySelector("title");
    if (!el) {
      return;
    }

    const observer = new MutationObserver(() => {
      setTitle(document.title);
    });
    observer.observe(el, { childList: true });

    return () => observer.disconnect();
  }, []);

  return title;
}
